export default __webpack_public_path__ + "static/media/017-shirt.bec6a74c.png";